import { createRoute, createRouter, redirect } from "@tanstack/react-router";
import { AppShell } from "./components/features/layout/app-shell";
import { AuthPage } from "./routes/auth/page";
import { CandidateDetailPage } from "./routes/candidates/[candidateId]/page";
import { CandidatesPage } from "./routes/candidates/page";
import { InterviewEntryPage } from "./routes/interview/entry-page";
import { InterviewPage } from "./routes/interview/page";
import { LpPage } from "./routes/lp/page";
import { rootRoute } from "./routes/root";
import { TemplatesPage } from "./routes/templates/page";
import { TermsPage } from "./routes/terms/page";

const appLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "app",
  component: AppShell,
});

const authRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/a",
  component: AuthPage,
});

const candidatesRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/candidates",
  component: CandidatesPage,
});

const candidateDetailRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/candidates/$candidateId",
  component: CandidateDetailPage,
});

const templatesRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/templates",
  component: TemplatesPage,
});

const interviewEntryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: InterviewEntryPage,
});

const legacyInterviewEntryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/u/interview",
  component: () => null,
  beforeLoad: () => {
    throw redirect({ to: "/", search: (current) => current });
  },
});

const interviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/u/interview/$interviewId",
  component: InterviewPage,
});

const lpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/lp",
  component: LpPage,
});

const termsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/terms",
  component: TermsPage,
});

export const routeTree = rootRoute.addChildren([
  authRoute,
  appLayoutRoute.addChildren([candidatesRoute, candidateDetailRoute, templatesRoute]),
  interviewEntryRoute,
  legacyInterviewEntryRoute,
  interviewRoute,
  lpRoute,
  termsRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
